export const getBenefitReportExcelColumnDefs = (benefitColumnNames: string[]) => {
	const cols = [
		{
			accessor: "fullName",
			header: "Mitarbeiter/in",
			type: "string",
		},
	];

	benefitColumnNames.forEach(benefitName => {
		cols.push({
			accessor: benefitName,
			header: benefitName,
			type: "currency",
		});
	});

	cols.push({
		accessor: "benefitsTotalCents",
		header: "Gesamt",
		type: "currency",
	});
	return cols;
};